var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewEmptySchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 4.24984H26.9166V1.4165H24.0833V4.24984H9.91658V1.4165H7.08325V4.24984H5.66659C4.10825 4.24984 2.83325 5.52484 2.83325 7.08317V29.7498C2.83325 31.3082 4.10825 32.5832 5.66659 32.5832H28.3333C29.8916 32.5832 31.1666 31.3082 31.1666 29.7498V7.08317C31.1666 5.52484 29.8916 4.24984 28.3333 4.24984ZM28.3333 29.7498H5.66659V11.3332H28.3333V29.7498Z",
    fill: "#00456F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmptySchedule);
export default __webpack_public_path__ + "static/media/new_empty_schedule.d4dff2e12b82371688ab5faf93ebdec2.svg";
export { ForwardRef as ReactComponent };